module.exports = __webpack_public_path__ + "img/ok.8c6bdd8f.svg";